module.exports = __webpack_public_path__ + "images/info-circle-light.svg";